<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>Processor设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <processor-list @refresh="refreshList"></processor-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions } from 'vuex';
import ProcessorList from './components/list';

export default {
  name: 'ProcessorConfig',
  components: {
    ProcessorList
  },
  methods: {
    ...mapActions('processorConfigSetting', ['list']),
    refreshList() {
      this.list();
    }
  },
  created() {
    this.list();
  }
};
</script>

<style lang="less" scoped></style>
